module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAUCAYAAAC07qxWAAAApElEQVQoke2QMQoCMRBFX9Z0VhY2YrFn8ARbC/bbeg8hmUqs9DA2llY2HmYFEa3GJoEkrMsewAcDM/MfCYzx3hNxzk2BPdAC87C+ikhjE8kAZ6Chhyrp178kAJv0qyK7ADugK8VJIR5F5N73dcknm1S1DnXSnDbJaqOqOvBq5DZW3I4RH8CiAmahDoWwCfuliLysiHQAzrl3IT5jBsPnyfiLg3wBv/tMU+jJT1kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/imgs/facebook.png
// module id = 210
// module chunks = 0